import styled from 'styled-components';
import { zIndexValues } from 'utils/styles';

export const DropzoneContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 40px;
  min-height: 250px;
  max-height: 350px;
  overflow-y: scroll;
  border-width: 2px;
  border-radius: 15px;
  border-style: solid;
  border-style: ${(props) => (props.containsFiles ? 'solid' : 'dashed')};
  background-color: ${(props) => props.theme.palette.background.main};
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

export const DropzoneOverlay = styled.p`
  position: absolute;
  top: 45%;
  left: 25%;
  color: ${(props) => props.theme.palette.text.main};
  opacity: ${(props) => (props.containsFiles ? 0.3 : 1)};
  z-index: ${zIndexValues.bottom};
`;
